module.exports = __webpack_public_path__ + "assets/media/level-07.93f94fc7.png";